import React, { useMemo } from 'react';

import { useRooftop } from '@store';
import ProductShellLayout from '@features/products/shell/ProductShellLayout';

import { useGetPartsReturnsInboundCountQuery } from './queries/getPartsReturnsInboundCount.query.generated';
import { resolvePartsDeliveryActions } from './resolvePartsDeliveryActions';
import { resolvePartsDeliveryTabs } from '@hopdrive/feature-portal-products';
import { PRODUCT_ROUTES } from '@features/products/productRoutes';

/**
 * Parts Delivery's mount of the product shell: reads the inbound-returns count (parts in transit
 * back to the counter) for the Returns tab badge and hands the resolved tab set and the product's
 * header actions to the layout.
 */
const PARTS_DELIVERY_ACTIONS = resolvePartsDeliveryActions();

const PartsDeliveryShellLayout: React.FC = () => {
  const rooftop = useRooftop();
  const inboundReturns =
    useGetPartsReturnsInboundCountQuery({
      variables: { customerId: rooftop?.id || 0 },
      skip: !rooftop?.id,
      fetchPolicy: 'cache-and-network',
    }).data?.delivery_returns_aggregate?.aggregate?.count ?? 0;

  const tabs = useMemo(() => resolvePartsDeliveryTabs(PRODUCT_ROUTES, inboundReturns), [inboundReturns]);

  return <ProductShellLayout product='parts-delivery' tabs={tabs} actions={PARTS_DELIVERY_ACTIONS} />;
};

export default PartsDeliveryShellLayout;
